import { Routes } from '@angular/router';
import { authGuard } from '@skylab-angular-shared/config';
import { canActivateAvailability, combineAsyncActivateGuards } from '@skylab-angular-shared/scenes';
import { UserPermissionKind } from '@skylab-shared/dataModel';
import { AppStates } from '@skylab-shared/scenes';
import { appInitGuard } from './app-init/app-init.guard';
import { LayoutComponent } from './layout/layout.component';
import { pathNotFoundCanActivate } from './path-not-found/path-not-found-can-active';

export const appRoutes: Routes = [
    {
        path: AppStates.allegroAuth.url,
        loadComponent: () => import('./technical-pages/allegro-auth-redirect.component').then(m => m.AllegroAuthRedirectComponent)
    },
    {
        path: AppStates.technicalPages.url,
        canActivate: [authGuard()],
        loadChildren: () => import ('./technical-pages/technical-pages.routes').then(m => m.technicalPagesRoutes)
    },
    {
        path: 't/:id',
        canActivate: [combineAsyncActivateGuards(authGuard(), appInitGuard())],
        component: LayoutComponent,
        children: [
            {
                path: AppStates.importSummary.url,
                loadComponent: () => import('./imports/import-summary.component').then(m => m.ImportSummaryComponent)
            },
            {
                path: AppStates.documentSale.url,
                loadChildren: () => import('./sales/src/app/sales.routes').then(m => m.saleRoutes),
            },
            {
                path: AppStates.dashboard.url,
                loadChildren: () => import('./dashboard/src/app/dashboard.routes').then(m => m.dashboardRoutes),
            },
            {
                path: AppStates.unsettledDocuments.url,
                loadChildren: () => import('./unsettled-documents/src/app/unsettled-documents.routes').then(m => m.unsettledDocumentsRoutes),
            },
            {
                path: AppStates.configurationMenu.url,
                loadChildren: () => import('./configuration/src/app/configuration.routes').then(m => m.configurationRoutes),
            },
            {
                path: AppStates.companyCreator.url,
                loadChildren: () => import('./company-creator/src/app/company-creator.routes').then(m => m.companyCreatorRoutes),
            },
            {
                path: AppStates.clients.url,
                loadChildren: () => import('./clients/src/app/clients.routes').then(m => m.clientRoutes),
            },
            {
                path: AppStates.orders.url,
                loadChildren: () => import('./orders/src/app/orders.routes').then(m => m.ordersRoutes),
            },
            {
                path: AppStates.products.url,
                loadChildren: () => import('./products/src/app/products.routes').then(m => m.productsRoutes),
            },
            {
                path: AppStates.eInvoicesReceived.url,
                loadChildren: () => import('./e-invoices/src/app/e-invoices.routes').then(m => m.eInovicesRoutes),
                canActivate: [canActivateAvailability([], [UserPermissionKind.ReceiveDocumentsFromKsef])]
            },
            {
                path: AppStates.reports.url,
                loadChildren: () => import('./reports/src/app/reports.routes').then(m => m.reportsRoutes),
            },
            {
                path: AppStates.accountancy.url,
                loadChildren: () => import('./accountancy/src/app/accountancy.routes').then(m => m.accountancyRoutes),
            },
            {
                path: AppStates.inventory.url,
                loadChildren: () => import('./inventory/src/app/inventory.routes').then(m => m.inventoryRoutes),
                canActivate: [canActivateAvailability(['Inventory'])]
            },
            {
                path: AppStates.purchases.url,
                loadChildren: () => import('./purchases/src/app/purchases.routes').then(m => m.purchaseRoutes)
            },
            {
                path: AppStates.pageUnavailable.url,
                loadComponent: () => import('./page-unavailable/page-unavailable.component').then(m => m.PageUnavailableComponent)
            },
            {
                path: '',
                redirectTo: AppStates.dashboard.url,
                pathMatch: 'full'
            },
            {
                path: '**',
                canActivate: [pathNotFoundCanActivate()],
                loadComponent: () => null!,
            }
        ]
    },
    {
        path: AppStates.unexpectedError.url,
        loadComponent: () => import('./technical-pages/unexpected-error.component').then(m => m.UnexpectedErrorComponent)
    },
    {
        path: '**',
        redirectTo: '/t/',
        pathMatch: 'full'
    },
];
